"use client"
import React from 'react';
import SimpelHeader from '../../common/SimpelHeader/SimpelHeader';
import SellerSection from '../../sections/SellerInfo/SellerSection';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import ProductCard from '../../Dcomponent/ProductCard/ProductCard';
import SellerSectionDesktop from '@/components/desktop/SellerSectionDesctop/SellerSectionDesctop';
import ProductDeskCard from '@/components/desktop/ProductDeskCard';
import ProductList from '@/components/desktop/ProductList';
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const ProfileMenu = ({ productDetails, products }) => {
  const sallerInfo = productDetails?.user?.phone;
  const sallerProducts = products?.filter((item) => item?.user.phone === sallerInfo);
  const { t } = useTranslation()
   // Ensure that logic only runs in the client
 if (typeof window === "undefined") {
  return null; // Prevent rendering this component during SSR
}

 if (!sallerProducts || !Array.isArray(sallerProducts)) {
    return (
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className='flex flex-col items-center justify-center mt-16'
      >
        <Image src={DefaultImage} alt='DefaultImage' />
        <p className='text-center my-2 text-[20px]'>{t('notFound.productNotFound')}</p>
      </motion.div>
    );
  }


  return (
    <>
      <SellerSectionDesktop sallerInfo={productDetails?.user} />
      <div className="  mb-20 mx-auto px-4 py-8">
      <motion.h2 
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        className="text-2xl font-bold mb-4"
      >
       
      </motion.h2>
      <motion.div 
        variants={container}
        initial="hidden"
        animate="show"
        // className="grid grid-cols-2 md:grid-cols-3 gap-4"
      >
        {/* {sallerProducts.map((product, index) => (
          <ProductDeskCard key={product.id || index} product={product} index={index} />
        ))} */}
        <ProductList products={sallerProducts} homeStatus tabStatus tabtitle={` ${t('products.listTitle')} - (${sallerProducts.length})`}/>
      </motion.div>
    </div>
    </>
  );
};

export default ProfileMenu;